<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><a id="page_5"><img alt="Image" height="16" src="images/top.jpg" width="500"/></a></p><a id="page_5">
<h2 class="h2"><span class="txbf">Contents</span></h2>
<p class="imageb"><img alt="Image" height="18" src="images/bottom.jpg" width="500"/></p>
<p class="indent"> </p>
</a><p class="toc-front"><a id="page_5"></a><a class="nounder" href="#/xhtml/foreword#foreword">Foreword</a></p>
<p class="indent"> </p>
<p class="toc-front1"><span class="small">EXCERPTS FROM</span><br/>How to Stop Worrying and Start Living</p>
<p class="indent"> </p>
<p class="toc-part"><a class="nounder" href="#/xhtml/part01#part01"><span class="small">PART ONE</span></a></p>
<p class="imagep"><img alt="Image" height="15" src="images/cbottom.jpg" width="500"/></p>
<p class="toc-part1"><a class="nounder" href="#/xhtml/part01#part01">Seven Ways to Peace and Happiness</a></p>
<p class="indent"> </p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch01">1 Find Yourself and Be Yourself: Remember, There Is No One Else on Earth like You</a></p>
<p class="indent"> </p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch02#ch02">2 Four Good Working Habits That Will Help Prevent Fatigue and Worry</a></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 What Makes You Tired—and What You Can Do About It</span></p>
<p class="indent"> </p>
<p class="toc-chap"><a id="page_6"></a><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 How to Banish the Boredom That Produces Fatigue, Worry, and Resentment</span></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Would You Take a Million Dollars for What You Have?</span></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Remember That No One Ever Kicks a Dead Dog</span></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Do This—and Criticism Can’t Hurt You</span></p>
<p class="indent"> </p>
<p class="toc-front1"><span class="small">EXCERPTS FROM</span><br/>How to Win Friends and Influence People</p>
<p class="indent"> </p>
<p class="toc-part"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample"><span class="small">PART TWO</span></span></p>
<p class="imagep"><img alt="Image" height="15" src="images/cbottom.jpg" width="500"/></p>
<p class="toc-part1"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample">Fundamental Techniques in Handling People</span></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 “If You Want to Gather Honey, Don’t Kick Over the Beehive”</span></p>
<p class="indent"> </p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 The Big Secret of Dealing with People</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 “He Who Can Do This Has the Whole World with Him. He Who Cannot Walks a Lonely Way”</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><a id="page_7"></a><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 Do This and You’ll Be Welcome Anywhere</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 How to Make People Like You Instantly</span></p>
<p class="indent"> </p>
<p class="toc-part"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample"><span class="small">PART THREE</span></span></p>
<p class="imagep"><img alt="Image" height="15" src="images/cbottom.jpg" width="500"/></p>
<p class="toc-part1"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample">Ways to Win People to Your Way of Thinking</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 A Sure Way of Making Enemies—and How to Avoid It</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 The High Road to Reason</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 The Secret of Socrates</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">16 How to Get Cooperation</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">17 An Appeal That Everybody Likes</span></p>
<p class="indent"> </p>
<p class="toc-part"><span class="nounder" href="#/xhtml/part04#part04" title="Link target outside of Sample"><span class="small">PART FOUR</span></span></p>
<p class="imagep"><img alt="Image" height="15" src="images/cbottom.jpg" width="500"/></p>
<p class="toc-part1"><span class="nounder" href="#/xhtml/part04#part04" title="Link target outside of Sample">Ways to Change People Without Giving Offense or Arousing Resentment</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">18 How to Criticize—and Not Be Hated for It</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample">19 Talk About Your Own Mistakes First</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><a id="page_8"></a><span class="nounder" href="#/xhtml/ch20#ch20" title="Link target outside of Sample">20 No One Likes to Take Orders</span></p>
<p class="indent"> </p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/ch21#ch21" title="Link target outside of Sample">21 Let the Other Person Save Face In a Nutshell</span></p>
<p class="indent"> </p>
<p class="toc-back"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5125aa64